var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUnavailable = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 128,
  height: 102,
  fill: "none",
  viewBox: "0 0 128 102"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1E1E1E",
  fillOpacity: 0.08,
  fillRule: "evenodd",
  d: "M22.996 101.25C10.352 101.25.102 91.223.102 78.854s10.25-22.396 22.894-22.396q.807 0 1.6.054a35.7 35.7 0 0 1-.56-6.304c0-19.56 15.842-35.417 35.383-35.417 15.6 0 28.842 10.107 33.549 24.135a33 33 0 0 1 3.394-.176c17.529 0 31.74 13.99 31.74 31.25 0 16.396-12.826 29.924-29.139 31.227v.023H22.995m12.484 0h-7.248z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E1E1E",
  strokeOpacity: 0.88,
  strokeWidth: 3.125,
  d: "M59.939 86.667a5.726 5.726 0 0 0 5.724-5.73 5.726 5.726 0 0 0-5.724-5.728 5.726 5.726 0 0 0-5.724 5.729 5.726 5.726 0 0 0 5.724 5.729Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E1E1E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.88,
  strokeWidth: 3.125,
  d: "m43.809 68.958 7.285-5.722-7.285-5.447M76.07 68.958l-7.285-5.722 7.284-5.447"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E1E1E",
  strokeLinecap: "round",
  strokeOpacity: 0.64,
  strokeWidth: 3.125,
  d: "M69.825 25.209c6.773 1.794 12.122 7.096 13.987 13.847"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E1E1E",
  strokeOpacity: 0.64,
  strokeWidth: 2.5,
  d: "M91.679 7.5c1.724 0 3.122-1.4 3.122-3.125a3.123 3.123 0 0 0-3.122-3.125 3.124 3.124 0 0 0-3.122 3.125A3.124 3.124 0 0 0 91.679 7.5Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#1E1E1E",
  fillOpacity: 0.64,
  d: "M123.939 24.166c1.724 0 3.122-1.399 3.122-3.125a3.124 3.124 0 0 0-3.122-3.125 3.124 3.124 0 0 0-3.122 3.125 3.124 3.124 0 0 0 3.122 3.125"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E1E1E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.64,
  strokeWidth: 3.125,
  d: "m99.752 15.58 8.698 8.707m.132-8.707-8.698 8.707zM1.563 34.163l6.243 6.25m0-6.25-6.243 6.25z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#1E1E1E",
  fillOpacity: 0.64,
  d: "M15.711 27.291c1.725 0 3.122-1.399 3.122-3.125a3.123 3.123 0 0 0-3.122-3.125 3.124 3.124 0 0 0-3.122 3.125 3.124 3.124 0 0 0 3.122 3.125"
})));
export default SvgUnavailable;